import React, { useEffect, useState } from 'react';
import { withAlert } from 'react-alert';
import PropTypes from 'prop-types';

// Components
import AgreementsInfo from 'nxComponents/Agreements/AgreementsInfo';
import GridContainer from 'components/Grid/GridContainer';

// Others
import apiClient from 'config/apiClient';
import { urlApi } from '../../config/app';

// Core components
import NxSpinner from '../../nxComponents/NxSpinner/NxSpinner';

function Agreements({ alert }) {
  const [agreements, setAgreements] = useState();
  const [loading, setLoading] = useState(true);

  const getAgreements = () => {
    apiClient.SEM.get(`${urlApi}/agreement/byRole`)
      .then(response => {
        setAgreements(response.data.data);
      })
      .catch(error => {
        console.error('getAgreements', error);
        alert.show('Ocurrió un problema al cargar los acuerdos, inténtalo más tarde', {
          type: 'error',
          timeout: 5000
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => getAgreements(), []);

  if (loading) {
    return <NxSpinner loading={loading} />;
  }

  return (
    <GridContainer justify="center">
      {agreements ? <AgreementsInfo agreements={agreements} /> : <h3>No se encontraron acuerdos</h3>}
    </GridContainer>
  );
}

Agreements.propTypes = {
  alert: PropTypes.object.isRequired
};

export default withAlert()(Agreements);
